import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { Formik } from "formik";
import pick from "lodash/pick";
import React, { useState } from "react";
import { AddressFormContent } from "./AddressFormContent";
var ADDRESS_FIELDS = ["city", "companyName", "countryArea", "firstName", "lastName", "country", "phone", "postalCode", "streetAddress1", "streetAddress2", "email", "vatNumber"];
export var AddressForm = function AddressForm(_ref) {
  var address = _ref.address,
      submit = _ref.handleSubmit,
      formId = _ref.formId,
      defaultValue = _ref.defaultValue,
      countriesOptions = _ref.countriesOptions,
      toDelete = _ref.toDelete,
      props = _objectWithoutProperties(_ref, ["address", "handleSubmit", "formId", "defaultValue", "countriesOptions", "toDelete"]);

  var addressWithPickedFields = {};

  if (address) {
    addressWithPickedFields = pick(address, ADDRESS_FIELDS);
  }

  if (defaultValue) {
    addressWithPickedFields.country = defaultValue;
  }

  var _useState = useState("person"),
      _useState2 = _slicedToArray(_useState, 2),
      accountType = _useState2[0],
      setAccountType = _useState2[1]; // TODO: remove temp helper which fills the form on checkout page
  // addressWithPickedFields = {
  //   ...addressWithPickedFields,
  //   email: "fomenko@brights.com.ua",
  //   city: "WARSAW",
  //   country: { country: "Poland", code: "PL" },
  //   postalCode: "00-001",
  //   streetAddress1: "asdf",
  //   streetAddress2: "asdf",
  // };
  // TODO: end


  return React.createElement(Formik, {
    initialValues: addressWithPickedFields,
    enableReinitialize: true,
    onSubmit: function onSubmit(values, _ref2) {
      var setSubmitting = _ref2.setSubmitting;

      if (submit) {
        submit(values);
      }

      setSubmitting(false);
    },
    validate: function validate(values) {
      var errors = {};

      if (toDelete) {
        return errors;
      }

      if (!values.companyName && accountType === "company") {
        errors.companyName = "required";
      }

      if (!values.vatNumber && accountType === "company") {
        errors.vatNumber = "required";
      }

      if (!(values === null || values === void 0 ? void 0 : values.email) && address) {
        errors.email = "required";
      }

      if (!values.firstName) {
        errors.firstName = "required";
      }

      if (!values.lastName) {
        errors.lastName = "required";
      }

      if (!values.phone) {
        errors.phone = "required";
      }

      if (!values.streetAddress1) {
        errors.streetAddress1 = "required";
      }

      if (!values.city) {
        errors.city = "required";
      }

      if (!values.postalCode) {
        errors.postalCode = "required";
      }

      if (!values.country) {
        errors.country = "required";
      }

      if (!values.countryArea) {
        errors.countryArea = "required";
      }

      return errors;
    }
  }, function (_ref3) {
    var handleChange = _ref3.handleChange,
        handleSubmit = _ref3.handleSubmit,
        handleBlur = _ref3.handleBlur,
        errors = _ref3.errors,
        values = _ref3.values,
        setFieldValue = _ref3.setFieldValue,
        setFieldTouched = _ref3.setFieldTouched;
    return React.createElement(React.Fragment, null, React.createElement(AddressFormContent, _extends({
      address: address,
      countriesOptions: countriesOptions,
      defaultValue: defaultValue,
      errors: errors,
      formId: formId,
      handleBlur: handleBlur,
      handleChange: handleChange,
      handleSubmit: handleSubmit,
      setFieldTouched: setFieldTouched,
      setFieldValue: setFieldValue,
      toDelete: toDelete,
      values: values
    }, {
      setAccountType: setAccountType,
      accountType: accountType
    }, props)));
  });
};